import { useEffect } from 'react';
import usePlayerStore from '@cont/ClassVideoPlayer/hooks/usePlayerStore';
import { useToggleable as useDrawer } from '@stores/toggleables';
import { DRAWER_IDS } from '@constants/index';
import { useRouter } from 'next/router';

const useClassVideo = (classInfo) => {
  const { setCurrentClassData, currentClassData } = usePlayerStore();
  const {
    closeElement: closePlayerDrawer,
    openElement: openPlayerDrawer,
    isOpen: isPlayerOpen
  } = useDrawer(DRAWER_IDS.COURSE_CLASS_PLAYER);
  const router = useRouter();

  useEffect(() => {
    setCurrentClassData(classInfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentClassData.uid) {
      openPlayerDrawer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClassData.uid]);

  useEffect(() => {
    return () => {
      closePlayerDrawer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      setCurrentClassData({});
    };

    router.events.on('routeChangeStart', handleRouteChange);

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { openPlayerDrawer, closePlayerDrawer, isPlayerOpen };
};

export default useClassVideo;
